import clsx from "clsx";
import type { PropsWithChildren, ReactNode } from "react";

type Props = PropsWithChildren<{
  title: ReactNode;
  icon: ReactNode;
  action?: ReactNode;
  className?: string;
}>;

export const Card = ({ title, icon, action, children, className }: Props) => {
  return (
    <div
      className={clsx(
        "overflow-clip rounded-2xl border border-solid border-stroke-neutral-soft",
        className,
      )}
    >
      <div className="flex items-center gap-2 border-b border-inherit bg-surface-accent-softer p-3">
        <span className="shrink-0">{icon}</span>
        <h3 className="font-medium text-text-title">{title}</h3>
        {action ? <div className="ms-auto shrink-0">{action}</div> : null}
      </div>
      <div className="p-3">{children}</div>
    </div>
  );
};
